

          
          
          window.Fandango.templates = window.Fandango.templates || {};
          window.Fandango.templates._tspShowtimesPlaceholderDesktop = function anonymous(_swig,_ctx,_filters,_utils,_fn
) {
  var _imports = {  };
  var _ext = _swig.extensions,
    _output = "";
_output += "<div class=\"js-showtimes-placeholder showtimes-placeholder__container\">\n    ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(3), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcache7c93f64153906fade66cb468fe93c8f7 = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n        <div class=\"showtimes-placeholder\">\n            <div class=\"showtimes-placeholder__header showtimes-placeholder__loading\"></div>\n\n            <div class=\"showtimes-placeholder__row\">\n                <div class=\"showtimes-placeholder__movie\">\n                    <div class=\"showtimes-placeholder__movie-poster showtimes-placeholder__loading\"></div>\n\n                    <div class=\"showtimes-placeholder__details\">\n                        <div class=\"showtimes-placeholder__title showtimes-placeholder__loading\"></div>\n                        <div class=\"showtimes-placeholder__data showtimes-placeholder__loading\"></div>\n                    </div>\n                </div>\n\n                <div class=\"showtimes-placeholder__group\">\n                    <div class=\"showtimes-placeholder__title showtimes-placeholder__loading\"></div>\n                    <div class=\"showtimes-placeholder__card showtimes-placeholder__loading\"></div>\n\n                    <div class=\"showtimes-placeholder__btn-list\">\n                        ";
(function () {
  var __l = ((typeof _ctx.Array !== "undefined") ? _ctx.Array : ((typeof Array !== "undefined") ? Array : _fn))(4), __len = (_utils.isArray(__l) || typeof __l === "string") ? __l.length : _utils.keys(__l).length;
  if (!__l) { return; }
    var _ctx__loopcacheb12aa6d05f1d0a74e08a27d0caf79086 = { loop: _ctx.loop, x: _ctx.x, __k: _ctx.__k };
    _ctx.loop = { first: false, index: 1, index0: 0, revindex: __len, revindex0: __len - 1, length: __len, last: false };
  _utils.each(__l, function (x, __k) {
    _ctx.x = x;
    _ctx.__k = __k;
    _ctx.loop.key = __k;
    _ctx.loop.first = (_ctx.loop.index0 === 0);
    _ctx.loop.last = (_ctx.loop.revindex0 === 0);
    _output += "\n                            <div class=\"showtimes-placeholder__btn showtimes-placeholder__loading\"></div>\n                        ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcacheb12aa6d05f1d0a74e08a27d0caf79086.loop;
  _ctx.x = _ctx__loopcacheb12aa6d05f1d0a74e08a27d0caf79086.x;
  _ctx.__k = _ctx__loopcacheb12aa6d05f1d0a74e08a27d0caf79086.__k;
  _ctx__loopcacheb12aa6d05f1d0a74e08a27d0caf79086 = undefined;
})();
_output += "\n                    </div>\n\n                    <div class=\"showtimes-placeholder__smp-btn showtimes-placeholder__loading\"></div>\n                </div>\n            </div>\n        </div>\n    ";
    _ctx.loop.index += 1; _ctx.loop.index0 += 1; _ctx.loop.revindex -= 1; _ctx.loop.revindex0 -= 1;
  });
  _ctx.loop = _ctx__loopcache7c93f64153906fade66cb468fe93c8f7.loop;
  _ctx.x = _ctx__loopcache7c93f64153906fade66cb468fe93c8f7.x;
  _ctx.__k = _ctx__loopcache7c93f64153906fade66cb468fe93c8f7.__k;
  _ctx__loopcache7c93f64153906fade66cb468fe93c8f7 = undefined;
})();
_output += "\n</div>\n";

  return _output;

}
          export default window.Fandango.templates._tspShowtimesPlaceholderDesktop;
          